/**
 * Global template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from "./lib/global";

require("./components/main-info-product");

const simpleSlider = document.querySelector(".simple-slider");
simpleSlider ? require("./components/simpleSlider") : null;

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "Global";

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const topBarWithSearch = document.querySelector(".show_search_and_call");
const headerV5 = document.querySelector(".header-v5");
const loaderWrapper = document.querySelector(
	".predictive-search__loading-state"
);
const drawerMenuClose = document.querySelectorAll(".menu-top__button-close");
const subMenuButtonClose = document.querySelector(
	".menu-top__button-close-submenu"
);
const menuList = document.querySelectorAll(".has-submenu.list-menu li");
const tabSlider = document.querySelector(".slider-container");
const countdown = document.querySelector("countdown");

/**
 * init - Initialize the page
 **/

drawerMenuClose.forEach((btn) => {
	btn.addEventListener("click", () => {
		const openMenu = document.body.querySelector(".menu-opening");
		const containerMenu = document.body.querySelector(
			".menu-drawer-container summary"
		);
		if (openMenu) {
			openMenu.classList.remove("menu-opening");
			setTimeout(() => {
				openMenu.removeAttribute("open");
			}, 500);
			document.body.classList.remove("overflow-hidden-tablet");
			containerMenu.setAttribute("aria-expanded", "false");
		}
	});
});

const handlerClickCloseButtonSubMenuDrawer = (e) => {
	const subMenuDrawers = document.querySelectorAll(".menu-drawer__menu");
	subMenuDrawers.forEach((menu) => {
		const detailsElements = menu.querySelectorAll("details");

		detailsElements.forEach((detailsElement) => {
			if (detailsElement.id) {
				const subMenuElement = document.getElementById(detailsElement.id);

				if (subMenuElement) {
					if (subMenuElement.hasAttribute("open")) {
						subMenuElement.classList.remove("menu-opening");

						if (subMenuButtonClose.classList.contains("active")) {
							subMenuButtonClose.classList.remove("active");
						}
						setTimeout(() => {
							subMenuElement.removeAttribute("open");
						}, 500);
						menu.classList.remove("submenu-open");
						subMenuElement
							.querySelector("summary")
							.setAttribute("aria-expanded", "false");
					}
				}
			}
		});
	});
};

if (subMenuButtonClose) {
	subMenuButtonClose.addEventListener(
		"click",
		handlerClickCloseButtonSubMenuDrawer
	);
}

menuList.forEach((menu) => {
	menu.addEventListener("click", (e) => {
		subMenuButtonClose.classList.add("active");
	});
});

topBarWithSearch ? document.body.classList.add("top-bar_search") : null;
tabSlider ? require("./components/tabSlider") : null;
countdown ? require("./components/countdown") : null;

setTimeout(() => {
	headerV5 ? (loaderWrapper.style.display = "flex") : null;
}, 2000);

window.upsellProduct = () => {
	const $product = document.querySelector('.product');
	const buttons = $product.querySelectorAll('.button-group > button');

	if(!buttons) return;

	const productExtrasWrapper = $product.querySelector('.product-extra--extrases');
	const fields = $product.querySelectorAll('.product-extra--extrases label');
	const btnAddToCard = $product.querySelector('.product-form__buttons > button');
	const textAlert = $product.querySelector('.alert-available-color-picker');

	if(btnAddToCard) btnAddToCard.setAttribute('disabled', '');
	
	buttons.forEach(element => {
		element.addEventListener('click', (event) => {
			event.preventDefault();
			buttons.forEach(btn => btn.classList.remove('active'));
			event.currentTarget.classList.toggle('active');
			if(event.currentTarget.dataset.value == 'colchon-and-estructura'){
				productExtrasWrapper.style.display = 'block';	
				btnAddToCard.setAttribute('disabled', '');
			}else{
				productExtrasWrapper.style.display = 'none';
				fields.forEach(label => {
					label.querySelector('input[name="id[]"]')?.setAttribute('disabled', 'true');
				})
				if(textAlert && !textAlert.classList.contains('hidden')) textAlert.classList.add('hidden');
				if(btnAddToCard.classList.contains('disabled')) btnAddToCard.classList.toggle('disabled', false)
				btnAddToCard.removeAttribute('disabled');
			}
		})
	})


	fields.forEach(label => {
		label.addEventListener('click', (e) => {
			e.preventDefault();

			const input = label.querySelector('input[name="id[]"]');
			
			if (!input) return;


			const allRadios = document.querySelectorAll('.product-extra--extrases input[name="id[]"]');
			allRadios.forEach(radio => {
				radio.checked = false
				radio.setAttribute('disabled', '');
			});

			input.checked = true;

			input.removeAttribute('disabled');
			btnAddToCard.removeAttribute('disabled');

			const colorPickers = label.querySelectorAll('.product-colors .product_related');
			if(!colorPickers) return;
			const variantValueSelected = $product.querySelector(".product-form__input select[name='options[Tamaño]'], .product-form__input select[name='options[Size]'], .product-form__input select[name='options[Misurare]']");

			const colorData = window.productUpsellData;

			colorPickers.forEach(color => {
				if(color.classList.contains('is-active')){

					const productId = color.dataset.upsellProductId;
					const variantSizeValue = variantValueSelected.value.toLowerCase().replace('cm', '').trim();
					const textAlert = $product.querySelector('.alert-available-color-picker');
					const input = color.closest('label').querySelector('input[name="id[]"]');
					
					const resultsVariantSize = colorData.find(value => {
						return value.product_upsell_id == productId && value.option == variantSizeValue;
					})					

					if(!resultsVariantSize){
						if(textAlert) textAlert.classList.remove('hidden');
						setTimeout(() => {
							btnAddToCard.classList.toggle('disabled', true);
						}, 300);
					}else{
						const { id } = resultsVariantSize;

						if(textAlert) textAlert.classList.add('hidden');
						input.value = id;
						btnAddToCard.removeAttribute('disabled');

						if(btnAddToCard.classList.contains('disabled')){
							btnAddToCard.classList.toggle('disabled', false);
						}
					}
				}
			})

		})
	})
}




window.upsellColorPicker = () => {
	const $product = document.querySelector('.product');
	const colorPickers = $product.querySelectorAll('.product-colors .product_related');

	if(!colorPickers) return;

	const variantValueSelected = $product.querySelector(".product-form__input select[name='options[Tamaño]'], .product-form__input select[name='options[Size]'], .product-form__input select[name='options[Misurare]']");
	const fields = $product.querySelectorAll('.product-extra--extrases label');
	const btnAddToCard = $product.querySelector('.product-form__buttons > button'); 
	const textAlert = $product.querySelector('.alert-available-color-picker');
	
	const colorData = window.productUpsellData;

	colorPickers.forEach(btn => {
		btn.addEventListener('click' , (event) => {
			event.preventDefault();

			const productId = btn.dataset.upsellProductId;
			const variantSizeValue = variantValueSelected.value.toLowerCase().replace('cm', '').trim();
			const input = btn.closest('label').querySelector('input[name="id[]"]');

			const resultsVariantSize = colorData.find(value => {
				return value.product_upsell_id == productId && value.option == variantSizeValue;
			})

			const thisColorPicker = btn.closest('.product-colors').querySelectorAll('.product_related');
			thisColorPicker.forEach(btn => btn.classList.remove('is-active'));
			btn.classList.add('is-active');

			if(!resultsVariantSize){
				if(textAlert) textAlert.classList.remove('hidden');
				setTimeout(() => {
					btnAddToCard.classList.toggle('disabled', true);
				}, 300);
			}else{
				const { id } = resultsVariantSize;

				if(textAlert) textAlert.classList.add('hidden');
						
				if (!input) return;

				input.value = id;
				btnAddToCard.removeAttribute('disabled');

				if(btnAddToCard.classList.contains('disabled')){
					btnAddToCard.classList.toggle('disabled', false);
				}
			}
		})
	});

	variantValueSelected.addEventListener('change', () => {
		if(!textAlert.classList.contains('hidden')) textAlert.classList.add('hidden');
		if(!btnAddToCard.classList.contains('disabled')) btnAddToCard.classList.toggle('disabled', true);

		fields.forEach(label => {
			label.querySelector('input[name="id[]"]')?.setAttribute('disabled', 'true');
		})
	})


}




if (document.body.clientWidth <= 767) {
	window.upsellSlider = () => {
		const upsellWrapper = document.querySelector(
			".cart-drawer .cart-drawer-upsell.upsell-desktop"
		);
		const slider = document.querySelector(".upsell-product");
		const slides = slider.getElementsByClassName("slide");
		let currentIndex = 0;
		let autoplay;

		// if ( upsellWrapper ) upsellWrapper.remove();

		function nextSlide() {
			slides[currentIndex].classList.remove("active");
			currentIndex = (currentIndex + 1) % slides.length;
			slides[currentIndex].classList.add("active");
		}

		function startAutoplay() {
			autoplay = setInterval(nextSlide, 4000);
		}

		function stopAutoplay() {
			clearInterval(autoplay);
		}

		slider.addEventListener("mouseenter", stopAutoplay);
		slider.addEventListener("mouseleave", startAutoplay);
		startAutoplay();
	};

	window.upsellSlider();
}


document.addEventListener('DOMContentLoaded', () => {
	const $product = document.querySelector('.product');
	const buttons = $product.querySelector('.button-group > button');

	if($product && buttons){
		window.upsellProduct();
		window.upsellColorPicker();
	}

})